function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1443",
  "data-name": "Group 1443",
  transform: "translate(-1054 -795)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_597",
  "data-name": "Rectangle 597",
  width: 18,
  height: 2,
  rx: 1,
  transform: "translate(1062 796)",
  fill: "#2294d2"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_598",
  "data-name": "Rectangle 598",
  width: 12,
  height: 2,
  rx: 1,
  transform: "translate(1068 803)",
  fill: "#2294d2"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_599",
  "data-name": "Rectangle 599",
  width: 12,
  height: 2,
  rx: 1,
  transform: "translate(1068 810)",
  fill: "#2294d2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_74",
  "data-name": "Ellipse 74",
  cx: 2,
  cy: 2,
  r: 2,
  transform: "translate(1054 795)",
  fill: "#2294d2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_75",
  "data-name": "Ellipse 75",
  cx: 2,
  cy: 2,
  r: 2,
  transform: "translate(1060 802)",
  fill: "#2294d2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_76",
  "data-name": "Ellipse 76",
  cx: 2,
  cy: 2,
  r: 2,
  transform: "translate(1060 809)",
  fill: "#2294d2"
}));

var SvgHierarchyView = function SvgHierarchyView(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHierarchyView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hierarchy-view.6be50f3b.svg";
export { ForwardRef as ReactComponent };